import * as React from "react";
import { Context } from "./_context";
export const KeypadDeleteIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.905 6.47 10.8 12.108l5.105 5.64-2.017 1.968L7 12.108 13.888 4.5l2.017 1.97Z", fill: "currentColor" }));
  return iconset[size];
};
KeypadDeleteIcon.iconId = "gdy0d7";
